import { useEffect, useState } from 'react';

export default function useAdornmentWidth({ deps, attr = 'track-adornment-width', position = 'Start' }) {
  const [adornmentWidth, setAdornmentWidth] = useState(0);

  const getHighestAdornmentWidth = () => {
    let elements = document.getElementsByClassName(`MuiInputAdornment-root MuiInputAdornment-position${position}`);

    if (elements.length === 0) {
      setTimeout(getHighestAdornmentWidth, 200);
      return;
    }

    elements = Array.from(elements).filter((element) => {
      const typographyChild = element.querySelector('.MuiTypography-root');
      return typographyChild?.getAttribute('attr') === attr;
    });

    let highestWidth = 0;
    for (const element of Array.from(elements)) {
      const typographyChild = element.querySelector('.MuiTypography-root');
      if (typographyChild) {
        const width = typographyChild.offsetWidth;
        if (width > highestWidth) highestWidth = width;
      }
    }

    if (highestWidth > 0) setAdornmentWidth(highestWidth);
  };

  useEffect(() => {
    const timer = setTimeout(getHighestAdornmentWidth, 0);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of Array.from(mutation.addedNodes)) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const hasAdornment =
              node.querySelector?.('.MuiInputAdornment-root') || node.classList?.contains('MuiInputAdornment-root');

            if (hasAdornment) {
              setTimeout(getHighestAdornmentWidth, 50);
            }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const handleResize = () => getHighestAdornmentWidth();
    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(getHighestAdornmentWidth, 0);
    return () => clearTimeout(timer);
  }, deps);

  return adornmentWidth;
}
